import { createFileRoute } from "@tanstack/react-router"

import { CheckedInPurchaseOrdersTab } from "@/screens/WarehouseReceiving/subfeatures/CheckedIn/components"

export const Route = createFileRoute("/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout/purchase-orders")({
  component: CheckedInPurchaseOrdersTab,
})
